import React from "react";

const CalendarStep = ({
  currentMonth,
  navigateMonth,
  getCalendarDays,
  isDateDisabled,
  isToday,
  handleDateSelect,
}) => {
  return (
    <div className="p-5 flex-1">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-baseline gap-1">
          <h4 className="text-base font-semibold text-[#101010]">
            {currentMonth.toLocaleDateString("en-US", {
              month: "long",
            })}
          </h4>
          <span className="text-sm font-medium text-[#6B7280]">
            {currentMonth.getFullYear()}
          </span>
        </div>
        <div className="flex gap-1">
          <button
            onClick={() => navigateMonth(-1)}
            className="w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-md transition-colors"
          >
            <svg
              className="w-3 h-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <button
            onClick={() => navigateMonth(1)}
            className="w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-md transition-colors"
          >
            <svg
              className="w-3 h-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>

      <div className="grid grid-cols-7 gap-0 mb-2">
        {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map((day) => (
          <div
            key={day}
            className="text-center text-xs font-medium text-[#9CA3AF] py-2"
          >
            {day}
          </div>
        ))}
      </div>

      <div className="grid grid-cols-7 gap-0">
        {getCalendarDays().map((date, index) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          const dateStr = `${year}-${month}-${day}`;

          const isCurrentMonth = date.getMonth() === currentMonth.getMonth();
          const isDisabled = isDateDisabled(date);
          const isTodayDate = isToday(date);
          const isWeekend = date.getDay() === 0 || date.getDay() === 6;

          return (
            <button
              key={index}
              onClick={() => (!isDisabled ? handleDateSelect(dateStr) : null)}
              disabled={isDisabled}
              className={`
                w-10 h-10 md:w-12 md:h-12 flex items-center justify-center text-sm font-medium transition-colors relative
                ${!isCurrentMonth ? "text-gray-300" : ""}
                ${
                  !isDisabled && !isWeekend
                    ? "hover:bg-[#E5E7EB] cursor-pointer text-[#101010]"
                    : "cursor-not-allowed opacity-50 text-[#9CA3AF]"
                }
                ${
                  isTodayDate
                    ? "bg-[#E5E7EB] text-[#101010] font-medium rounded-md"
                    : ""
                }
                ${!isCurrentMonth ? "invisible" : ""}
              `}
            >
              {date.getDate()}
              {isTodayDate && (
                <div className="absolute bottom-1 w-1 h-1 bg-[#101010] rounded-full"></div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CalendarStep;
